<template>
  <div class="relative">
    <svg
      viewBox="0 0 100 100"
      class="rounded-full"
      :class="{'h-12 w-12': !large, 'h-20 w-20' : large}"
      style="transform: rotate(-90deg);background: linear-gradient(132deg, rgba(69,32,31,1) 0%, rgba(50,28,38,1) 100%);"
    >
      <defs>
        <linearGradient
          :id="gradientId"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="0%"
        >
          <stop
            offset="0%"
            stop-color="#622567"
          />
          <stop
            offset="100%"
            stop-color="#DB4433"
          />
        </linearGradient>
      </defs>
      <circle
        ref="pie"
        r="25"
        cx="50"
        cy="50"
        :stroke="`url(#${gradientId})`"
        stroke-width="50"
        style="transition: stroke-dasharray 1s ease;"
      />
      <circle
        :r="large ? '38' : '25'"
        cx="50"
        cy="50"
        fill="currentColor"
        class="text-gray-900"
      />
    </svg>
    <span
      class="absolute inset-0 flex items-center justify-center"
      :class="{'text-xl font-black':large}"
    >{{ percentage }}%</span>
  </div>
</template>

<script>
export default {
  props: {
    percentage: {
      type: Number,
      default: 0
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    gradientId () {
      return '_' + Math.random().toString(36).substr(2, 9)
    }
  },
  watch: {
    percentage: {
      handler: 'generatePie',
      immediate: true
    }
  },
  methods: {
    generatePie () {
      const total = 158 // 2π * 25

      this.$nextTick(() => {
        let result = this.percentage > 0 ? (this.percentage * total) / 100 : 0
        if (this.$refs.pie) {
          this.$refs.pie.style.strokeDasharray = result + ' ' + total
        }
      })
    }

  }
}
</script>
